import {api} from '@/http'

// 获取公司详情
const getCompanyDesc = (id, callback, back) => {
  api('/api/enterprise/' + id, 'get', '', callback, back)
}

// 获取招聘职位
const getCompanyPositionList = (id, data, callback, back) => {
  api('/api/enterprise/' + id + '/position', 'get', data, callback, back)
}

// 添加关注
const companyFollow = (id, data, callback, back) => {
  api('/api/enterprise/' + id + '/follow', 'post', data, callback, back)
}

// 关注取消
const companyFollowDel = (id, callback, back) => {
  api('/api/enterprise/' + id + '/follow', 'del', '', callback, back)
}

// 举报
const companyReport = (id, data, callback, back) => {
  api('/api/enterprise/' + id + '/complaint', 'post', data, callback, back)
}

export default {
  getCompanyDesc,
  getCompanyPositionList,
  companyFollow,
  companyFollowDel,
  companyReport
}



// WEBPACK FOOTER //
// ./src/api/company/index.js